export * from './report.module';

export { ReportComponent } from './components/report.component';
export { ReportMainComponent } from './components/report-main.component';
export { ReportPapersComponent } from './components/report-papers.component';
export { ReportPartsComponent } from './components/report-parts.component';
export { ReportSummaryComponent } from './components/report-summary.component';
export { ReportReviewComponent } from './components/report-review.component';


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/index.ts